import { gql } from '@apollo/client';

export const updateJournalEntryMutation = gql`
    mutation UpdateJournalEntry($id: String!, $data: JournalEntryUpdateInput!) {
        updateJournalEntry(id: $id, data: $data) {
            id
            text
            rating
            ritualId
            ritualType
            taskName
            promptText
            createdAt
        }
    }
`;
